import { addSectionToUserURL } from "../../../utils/ConstantsURL";

export const useAddSections = (token) => {
  const addSections = async (userId, documentId, sectionId) => {
    try {
      const response = await fetch(addSectionToUserURL(documentId), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: userId,
          section_id: sectionId,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error al eliminar la sección");
      }
    } catch (error) {
      console.error("Error al eliminar la sección:", error.message);
    } finally {
    }
  };

  return { addSections };
};
